import { Components } from "formiojs";
/* imports */
import facilitiesCustomComp from "./Facilities";
import photoCapture from "./capturePhoto";
import geolocation from "./Geolocation";
import userGeolocation from "./UserGeolocation";
import textFieldInputValidationCustomComp from "./TextFieldInputValidation";
import confirmationMessagesCustomComp from "./ConfirmationMessages";
import qrcodeCustomComp from "./qrCode";
import radioButtonCustomComp from "./CustomRadioButton";
import dynamicTableDataComp from "./DynamicTableData";
import labelCustomComponent from "./customLabel";
import customHtml from "./CustomHTMLElement";
import dynamicDropDownCustomComp from "./DynamicDropdown";
import dropdownCustomComp from "./Dropdown";
import companyContractsCustomComp from "./CompanyContracts";
import companyMembersCustomComp from "./CompanyMembers";
import photoCaptureCustomComp from "./PhotoCapture";
import userCompanyCustomComp from "./UserCompany"
/* 🔥 REGISTER HERE */
const components = {
  facilities: facilitiesCustomComp,
  photoCapture,
  geolocation,
 // conditionalDropDown: conditionalDropDownCustomComp,
  //company: companyCustomComp,
  //companyUsers: companyUsersCustomComp,
 // companyRelation: companyRelationCustomComp,
 // getAll: getAllCustomComp,
  //generalAPI: generalAPICustomComp,
 // normalSelect: normalSelectCustomComp,
 // loggedInUserDetails: loggedInUserDetailsCustomComp,
 // setValues: setValuesCustomComp,
 // confirmation: confirmationCustomComp,
 // gisMapCustomComp: gisMapCustomComp,
 // map: mapCustomComp,
 // textFieldValidation: textFieldValidationCustomComp,
  dynamicDropDownCustomComp: dynamicDropDownCustomComp,
  dropdownCustomComp: dropdownCustomComp,
  //autoComplete: autoCompleteCustomComp,
  companyContractsCustomComp: companyContractsCustomComp,
  companyMembersCustomComp: companyMembersCustomComp,
  photoCaptureCustomComp: photoCaptureCustomComp,
  userCompany: userCompanyCustomComp,
  userGeolocation,
  textFieldInputValidationCustomComp: textFieldInputValidationCustomComp,
  confirmationMessagesCustomComp: confirmationMessagesCustomComp,
  qrcode: qrcodeCustomComp,
  radioButton: radioButtonCustomComp,
  dynamicTableDataComp: dynamicTableDataComp,
  labelCustomComponent: labelCustomComponent,
  customHtml
};

Object.entries(components).forEach(([key, component]) => {
  if (!Components.components[key]) {
    Components.addComponent(key, component);
  }
});
console.log("✅ FormIO custom components registered");
export default components;